/* [UB2R ADDED] - 인포 팝업을 위한 전역 변수 */
let ub2rInfoModal, ub2rInfoModalContent, ub2rCurrentDescription = "";

(function(){
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches; // ◀◀ 1. 모바일 확인 함수 추가
  const qs=(s,r=document)=>r.querySelector(s);
  const qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));

  let overlay,mediaWrap,thumbsWrap,sizesWrap,backBtn,prevBtn,nextBtn,titleEl,priceEl,overlayCount;
  let items=[],idx=-1,mediaSources=[],mIdx=0;

  let cartMap={},cartCount=0,pending={},committing=false,flushTimer=null;
  let historyBound=false,overlayOpen=false,isClosing=false,stabilizeTimer=null,pushedState=false;

  let suppressUntil=0;
  function suppress(ms){suppressUntil=Date.now()+ms}

  /* [UB2R MODIFIED] - 팝업 관련 함수 2개를 이 IIFE 스코프 최상단으로 이동 */
  
  /* [UB2R ADDED] - 팝업을 여는 함수 */
  function openInfoModal() {
    // 팝업 HTML이 없으면 먼저 생성
    if (!ub2rInfoModal) {
      ub2rInfoModal = document.createElement("div");
      ub2rInfoModal.id = "ub2r-info-modal"; // CSS가 이 ID를 사용합니다
      ub2rInfoModal.style.display = "none"; // 기본 숨김
      ub2rInfoModal.innerHTML = 
        '<div class="ub2r-info-modal-backdrop"></div>'+ // 바탕(배경)
        '<div class="ub2r-info-modal-wrap">'+
          '<div class="ub2r-info-modal-content">'+
            // p.description이 여기에 삽입됩니다
          '</div>'+
          '<button type="button" class="ub2r-info-modal-close" aria-label="Close">&times;</button>'+
        '</div>';
      document.body.appendChild(ub2rInfoModal);
      
      ub2rInfoModalContent = qs(".ub2r-info-modal-content", ub2rInfoModal);
      
      // 팝업 닫기 (바탕이나 X버튼 클릭 시)
      ub2rInfoModal.addEventListener("click", e => {
        if (e.target.classList.contains("ub2r-info-modal-backdrop") || e.target.closest(".ub2r-info-modal-close")) {
          e.preventDefault();
          e.stopPropagation();
          ub2rInfoModal.style.display = "none";
        }
      });
    }
    
    // Description 내용을 팝업에 삽입하고 보여주기
    ub2rInfoModalContent.innerHTML = ub2rCurrentDescription; // 저장된 description(HTML)을 삽입
    ub2rInfoModal.style.display = "block"; // 팝업 보이기
  }

  function fmt(c){const v=(c||0)/100;try{const code=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||"USD";return new Intl.NumberFormat(undefined,{style:"currency",currency:code}).format(v)}catch(e){return "$"+v.toFixed(2)}}

  function getView(){try{return localStorage.getItem("ub2r_view")||"men"}catch(e){return "men"}}
  function setView(v){try{localStorage.setItem("ub2r_view",v)}catch(e){};const wrap=qs(".ub2r-wrap");if(wrap)wrap.dataset.view=v;filter(v);markToggle(v)}
  function filter(v){qsa(".ub2r-card").forEach(c=>{const g=(c.getAttribute("data-g")||"").toLowerCase();c.style.display=(g.split(/\s+/).includes(v)||g==="")?"":"none"})}
  function markToggle(v){qsa(".ub2r-toggle-btn").forEach(b=>b.classList.toggle("is-active",(b.dataset.view||"").toLowerCase()===v))}

  function ensureOverlay(){
    if(overlay) return;
    overlay=document.createElement("div");
    overlay.id="ub2r-overlay";
    overlay.innerHTML=
      '<div class="ub2r-stage">'+
        '<div class="ub2r-cartbtn" data-action="open-cart"><a href="/cart" data-action="open-cart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7z"></path><path d="M9 7a3 3 0 016 0"></path></svg><span class="ub2r-count">0</span></a></div>'+
        '<button class="ub2r-nav ub2r-nav--back" type="button"><span>&lt;</span></button>'+
        '<button class="ub2r-nav ub2r-nav--prev" type="button"><span>&lt;</span></button>'+
        '<button class="ub2r-nav ub2r-nav--next" type="button"><span>&gt;</span></button>'+
        '<div class="ub2r-media"><div class="ub2r-thumbs"></div></div>'+
        '<div class="ub2r-sheet"><div class="ub2r-sheet-inner">'+
          
          '<div class="ub2r-title"></div>'+
          '<div class="ub2r-price"></div>'+
          '<div class="ub2r-sizes"></div>'+
        '</div></div>'+
      '</div>';
    document.body.appendChild(overlay);
    mediaWrap=qs(".ub2r-media",overlay);
    thumbsWrap=qs(".ub2r-thumbs",overlay);
    sizesWrap=qs(".ub2r-sizes",overlay);
    backBtn=qs(".ub2r-nav--back",overlay);
    prevBtn=qs(".ub2r-nav--prev",overlay);
    nextBtn=qs(".ub2r-nav--next",overlay);
    titleEl=qs(".ub2r-title",overlay);
    priceEl=qs(".ub2r-price",overlay);
    overlayCount=qs(".ub2r-count",overlay);

    /* [UB2R MODIFIED] - 기존 '바탕' 클릭 리스너만 남겨둠 */
    overlay.addEventListener("click",e=>{if(e.target===overlay){suppress(500);close(true)}});
    
    const backHandler=(e)=>{e.preventDefault();e.stopPropagation();suppress(500);close(true)};
    backBtn.addEventListener("pointerdown",backHandler);
    backBtn.addEventListener("click",backHandler);
    prevBtn.addEventListener("click",e=>{e.preventDefault();e.stopPropagation();prev()});
    nextBtn.addEventListener("click",e=>{e.preventDefault();e.stopPropagation();next()});
    document.addEventListener("keydown",e=>{if(!overlayOpen)return;if(e.key==="Escape"){suppress(500);close(true)}if(e.key==="ArrowLeft")prev();if(e.key==="ArrowRight")next()});

    /* [UB2R REMOVED] - (i) 버튼 클릭 리스너를 여기서 제거 (openByIndex로 이동) */

    // ◀◀ 2. 수정됨 (sizesWrap 클릭 이벤트)
    sizesWrap.addEventListener("click",e=>{
      // --- 1. 새로운 모바일 버튼 로직 ---
      const sizeBtn = e.target.closest('.ub2r-size-btn');
      if (sizeBtn && !sizeBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        const vid = parseInt(sizeBtn.dataset.vid, 10);
        if (!vid) return;
        
        changeQtyImmediate(vid, 1); // 1개 담기
        
        // 클릭 피드백
        sizeBtn.classList.add('is-added');
        setTimeout(() => sizeBtn.classList.remove('is-added'), 400);
        return;
      }

      // --- 2. 기존 데스크탑 버튼 로직 (유지) ---
      const inc=e.target.closest('[data-qty-btn="inc"]');
      const dec=e.target.closest('[data-qty-btn="dec"]');
      if(!inc&&!dec) return;
      const row=e.target.closest(".ub2r-size");
      if(!row) return;
      const ip=qs('input[data-vid]',row);
      if(!ip) return;
      const vid=parseInt(ip.dataset.vid,10);
      if(!vid) return;
      if(inc) changeQtyImmediate(vid,1);
      if(dec) changeQtyImmediate(vid,-1);
    });
    
    sizesWrap.addEventListener("change",e=>{
      const ip=e.target.closest('input[data-vid]');
      if(!ip) return;
      const vid=parseInt(ip.dataset.vid,10);
      let n=Math.max(0,parseInt(ip.value||"0",10)||0);
      ip.value=String(n);
      cartMap[vid]=n;
      reflectCount(totalFromMap());
      pending[vid]=n;
      scheduleFlush(70);
    });
    if(!historyBound){
      window.addEventListener("popstate",function(){if(overlayOpen){suppress(500);close(false)}});
      historyBound=true;
    }
  }

  function open(){
    ensureOverlay();
    overlay.style.display="block";
    overlayOpen=true;
    isClosing=false;
    document.body.style.overflow="hidden";
    if(!pushedState){try{history.pushState({ub2r:1},"");pushedState=true}catch(e){}}
    try{document.dispatchEvent(new Event("ub2r:overlay-open"))}catch(e){}
  }

  function close(fromUi){
    /* [UB2R ADDED] - 메인 오버레이 닫을 때 인포 팝업도 닫기 */
    if (ub2rInfoModal && ub2rInfoModal.style.display === "block") {
      ub2rInfoModal.style.display = "none";
    }

    if(isClosing) return;
    isClosing=true;
    overlay.style.display="none";
    overlayOpen=false;
    document.body.style.overflow="";
    reflectCount(cartCount);
    if(stabilizeTimer) clearTimeout(stabilizeTimer);
    stabilizeTimer=setTimeout(()=>reflectCount(cartCount),120);
    if(fromUi&&pushedState){try{}catch(e){} pushedState=false}
    setTimeout(()=>{isClosing=false},120);
    try{document.dispatchEvent(new Event("ub2r:overlay-close"))}catch(e){}
  }

  function prev(){if(idx>0) openByIndex(idx-1)}
  function next(){if(idx<items.length-1) openByIndex(idx+1)}

  function headerNodes(){
    const sels=["[data-cart-count]","[data-cart-count-bubble]",".cart-count",".cart-count-bubble",".header__icon .counter",".header__icon .cart-count",".header__icon--cart .cart-count",".header__icon--cart [aria-hidden]",".ub2r-header-cart .ub2r-count"];
    const nodes=[];sels.forEach(s=>qsa(s).forEach(n=>nodes.push(n)));return nodes;
  }

  function reflectCount(n){
    cartCount=n;
    if(overlayCount) overlayCount.textContent=String(n||0);
    headerNodes().forEach(node=>{
      node.textContent=String(n||0);
      const bubble=node.closest(".cart-count-bubble,[data-cart-count-bubble]");
      if(bubble){bubble.removeAttribute("hidden");bubble.style.display=(n>0)?"inline-flex":"none"}
    });
    try{localStorage.setItem("ub2r_cart_count",String(n))}catch(e){}
    document.dispatchEvent(new CustomEvent("ub2r:cartcount",{detail:{count:n}}));

    // ◀◀ 3. 추가됨 ($ 버튼 활성화 로직)
    const checkoutBtn = qs('.ub2r-checkout-btn', overlay);
    if (checkoutBtn) {
      const isDisabled = n === 0;
      checkoutBtn.disabled = isDisabled;
      checkoutBtn.classList.toggle("is-disabled", isDisabled);
    }
  }

  function totalFromMap(){let s=0;for(const k in cartMap){s+=cartMap[k]||0}return s}
  function setCartFromCartJs(c){cartMap={};(c.items||[]).forEach(it=>{cartMap[it.variant_id]=(cartMap[it.variant_id]||0)+it.quantity});reflectCount(c.item_count||totalFromMap());syncInputsFromMap()}
  async function fetchCart(){const r=await fetch("/cart.js",{credentials:"same-origin"});return r.json()}
  async function syncCart(){try{const c=await fetchCart();setCartFromCartJs(c);return c}catch(e){reflectCount(parseInt(localStorage.getItem("ub2r_cart_count")||"0",10)||0);return {items:[],item_count:cartCount}}}

  function setHero(src,alt){mediaWrap.querySelectorAll("img.ub2r-hero").forEach(n=>n.remove());if(!src)return;const img=document.createElement("img");img.className="ub2r-hero";img.src=src;img.alt=alt||"";mediaWrap.appendChild(img);try{img.addEventListener("load",()=>{document.dispatchEvent(new Event("ub2r:media-change"))},{once:true})}catch(e){}}
  function buildThumbs(){thumbsWrap.innerHTML="";mediaSources.forEach((s,i)=>{const b=document.createElement("button");b.type="button";b.className="ub2r-thumb"+(i===mIdx?" is-active":"");b.addEventListener("click",()=>{mIdx=i;setHero(mediaSources[i],titleEl.textContent||"");qsa(".ub2r-thumb",thumbsWrap).forEach((t,j)=>t.classList.toggle("is-active",j===i))});thumbsWrap.appendChild(b)} )}

  function updateAllQtyInputs(vid,val){
    qsa('.ub2r-sizes input[data-vid="'+vid+'"]').forEach(ip=>{ip.value=String(val);ip.dispatchEvent(new Event("input",{bubbles:true}))});
    qsa('.ub2r-qa__input[data-variant-id="'+vid+'"]').forEach(ip=>{ip.value=String(val);ip.dispatchEvent(new Event("input",{bubbles:true}))});
  }

  function syncInputsFromMap(){
    qsa('.ub2r-sizes input[data-vid]').forEach(i=>{const v=parseInt(i.dataset.vid,10);i.value=String(cartMap[v]||0)});
    qsa('.ub2r-qa__input[data-variant-id]').forEach(i=>{const v=parseInt(i.dataset.variantId||i.dataset.variantid||i.getAttribute("data-variant-id"),10);if(v)i.value=String(cartMap[v]||0)});
  }

  function scheduleFlush(delay=70){
    if(flushTimer) clearTimeout(flushTimer);
    flushTimer=setTimeout(async()=>{
      flushTimer=null;
      if(Object.keys(pending).length===0) return;
      if(committing){scheduleFlush(70);return}
      const payload={updates:{...pending}};
      pending={};
      committing=true;
      try{
        const r=await fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify(payload)});
        await r.json();
        if(Object.keys(pending).length===0){await syncCart()}
      }catch(e){}
      committing=false;
      if(Object.keys(pending).length>0) 
        scheduleFlush(0);
    },delay);
  }

  function changeQtyImmediate(vid,delta){
    const next=Math.max(0,(cartMap[vid]||0)+delta);
    cartMap[vid]=next;
    updateAllQtyInputs(vid,next);
    reflectCount(totalFromMap());
    pending[vid]=next;
    scheduleFlush(70);
  }

  function handleFromNode(n){
    const d=n.getAttribute("data-handle")||n.dataset.handle||n.getAttribute("data-product-handle")||n.dataset.productHandle;
    if(d) return d;
    const a=n.closest('a[href*="/products/"]')||n.querySelector('a[href*="/products/"]');
    if(a){const m=a.getAttribute("href").match(/\/products\/([^\/?#]+)/);if(m) return m[1]}
    const url=n.getAttribute("data-product-url")||n.dataset.productUrl; if(url){const m=url.match(/\/products\/([^\/?#]+)/);if(m) return m[1]}
    return null;
  }

  async function load(handle){const r=await fetch("/products/"+handle+".js",{credentials:"same-origin"});if(!r.ok) throw 0;return r.json()}

  async function openByIndex(i){
    idx=i;
    const el=items[idx];
    const handle=handleFromNode(el);
    if(!handle){const a=el.closest('a[href]')||el.querySelector('a[href]');if(a) location.href=a.href;return}
    try{
      const [p,c]=await Promise.all([load(handle),syncCart()]);
      
      /* [UB2R ADDED] - 상품 description을 전역 변수에 저장 */
      ub2rCurrentDescription = p.description || "<p>No description available.</p>";

      ensureOverlay();open();
      mediaWrap.querySelectorAll("img.ub2r-hero").forEach(n=>n.remove());
      sizesWrap.innerHTML="";
      
      /* [UB2R MODIFIED] - 제목과 인포 버튼을 함께 삽입 */
      titleEl.innerHTML = (p.title || "") + ' <button type="button" class="ub2r-info-btn" aria-label="Product Information">i</button>';

      /* [UB2R ADDED] - 동적으로 생성된 인포 버튼에 클릭 이벤트 직접 연결 */
      const infoBtn = qs(".ub2r-info-btn", titleEl);
      if (infoBtn) {
        infoBtn.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation(); // 이 버튼 클릭이 '바탕' 클릭으로 전파되는 것을 막음
          openInfoModal(); // [UB2R MODIFIED] - 이제 이 함수는 상위 스코프에 정의되어 있음
        });
      }

      const base=((p.variants&&p.variants[0]&&p.variants[0].price)||p.price||0);
      priceEl.textContent=fmt(base);
      mediaSources=[];
      if(Array.isArray(p.media)&&p.media.length){p.media.forEach(m=>{const u=m.src||(m.preview_image&&m.preview_image.src);if(u) mediaSources.push(u)})}
      else if(Array.isArray(p.images)&&p.images.length){mediaSources=p.images.slice()}
      else if(p.image&&p.image.src){mediaSources=[p.image.src]}
      mIdx=0;setHero(mediaSources[0]||"",p.title||"");buildThumbs();
      setCartFromCartJs(c);

      // ◀◀ 4. 수정됨 (사이즈 영역 HTML 생성 분기)
      if(Array.isArray(p.variants)){
        if (isMobile()) {
          // --- 1. 새로운 모바일 로직 ---
          const grid = document.createElement("div");
          grid.className = "ub2r-size-grid";
          
          p.variants.forEach(v => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "ub2r-size-btn";
            btn.setAttribute("data-vid", String(v.id));

            if (!v.available) {
              btn.classList.add("is-sold-out");
               btn.disabled = true;
              btn.innerHTML = `<span>${v.title || "Default"}</span><div class="ub2r-sold-out-x">X</div>`;
            } else {
              btn.innerHTML = `<span>${v.title || "Default"}</span><div class="ub2r-sold-out-x"></div>`;
            }
            grid.appendChild(btn);
          });
          sizesWrap.appendChild(grid);

          const checkoutRow = document.createElement("div");
          checkoutRow.className = "ub2r-checkout-row";
          const checkoutBtn = document.createElement("button");
          checkoutBtn.type = "button";
          checkoutBtn.className = "ub2r-checkout-btn";
          checkoutBtn.textContent = "$";
          
          // 카트 수량(cartCount는 이 함수 상단에서 이미 업데이트됨)
          if (cartCount === 0) {
            checkoutBtn.disabled = true;
            checkoutBtn.classList.add("is-disabled");
          }
          
          checkoutBtn.addEventListener("click", () => { 
            if (cartCount > 0) location.href = "/checkout"; 
          });
          checkoutRow.appendChild(checkoutBtn);
          sizesWrap.appendChild(checkoutRow);

        } else {
          // --- 2. 기존 데스크탑 로직 (유지) ---
          p.variants.forEach(v=>{
            const row=document.createElement("div");row.className="ub2r-size";
            const name=document.createElement("div");name.textContent=v.title||"Default";
            const right=document.createElement("div");right.className="ub2r-qty";
            const minus=document.createElement("button");minus.type="button";minus.setAttribute("data-qty-btn","dec");minus.textContent="−";
            const input=document.createElement("input");input.type="number";input.min="0";input.value=String(cartMap[v.id]||0);input.setAttribute("data-vid",String(v.id));
    
            const plus=document.createElement("button");plus.type="button";plus.setAttribute("data-qty-btn","inc");plus.textContent="+";
            right.appendChild(minus);right.appendChild(input);right.appendChild(plus);
            row.appendChild(name);row.appendChild(right);
     
            sizesWrap.appendChild(row);
          });
        }
      }
      syncInputsFromMap();
      try{document.dispatchEvent(new Event("ub2r:media-change"))}catch(e){}
    }catch(e){
      const a=el.closest('a[href]')||el.querySelector('a[href]');if(a) location.href=a.href;else location.href="/products/"+handle;
    }
  }

  function collectItems(){
    const nodes=new Set();
    qsa(".ub2r-card").forEach(n=>nodes.add(n));
    qsa('[data-handle],[data-product-handle]').forEach(n=>nodes.add(n));
    qsa('a[href*="/products/"]').forEach(a=>{const c=a.closest(".ub2r-card")||a.closest('[data-handle],[data-product-handle]')||a;nodes.add(c)});
    items=Array.from(nodes).filter(n=>n&&n.offsetParent!==null);
  }

  function bind(){
    document.addEventListener("click",e=>{
      const t=e.target.closest(".ub2r-toggle-btn,[data-view],[data-toggle-view],img[src*='ub2r_male'],img[src*='male_centered_'],img[src*='ub2r_female'],img[src*='female_centered_']");
      if(t){
        let v=((t.dataset.view||t.dataset.toggleView)||"").toLowerCase();
        if(!v){const a=t.closest("[data-view],[data-toggle-view]");if(a){v=((a.dataset.view||a.dataset.toggleView)||"").toLowerCase();}}
        if(!v){v="men"}
        setView(v);e.preventDefault();return
      }
    });
    document.addEventListener("click",e=>{
      if(Date.now()<suppressUntil) return;
      if(overlayOpen||isClosing) return;
      const target=e.target;
      const el=target.closest(".ub2r-card,[data-handle],[data-product-handle],a[href*=\"/products/\"]");
      if(!el) return;
      collectItems();
      const index=items.indexOf(el.closest(".ub2r-card,[data-handle],[data-product-handle]")||el);
      if(index<0) return;
      e.preventDefault();
      openByIndex(index);
    });
  }

  function boot(){
    /* [UB2R REMOVED] - ensureInfoModal() 호출을 여기서 제거 (openInfoModal이 스스로 처리) */
    setView(getView());
    collectItems();
    bind();
    try{reflectCount(parseInt(localStorage.getItem("ub2r_cart_count")||"0",10)||0)}catch(e){}
    syncCart();
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot)}else{boot()}
})();
(function(){
  function ub2rSetScrollbarWidth(){
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if(sbw < 0) sbw = 0;
    document.documentElement.style.setProperty('--ub2r-sbw', sbw + 'px');
  }
  ub2rSetScrollbarWidth();
  window.addEventListener('resize', ub2rSetScrollbarWidth, {passive:true});
  window.addEventListener('load', ub2rSetScrollbarWidth, {once:true});
})();
(function(){
  var overlay,content,backBtn,openState=false,historyBound=false,timer=null;
  function reflect(n){ if(n==null) n=0; try{ localStorage.setItem("ub2r_cart_count",String(n)) }catch(e){}; var ev=new CustomEvent("ub2r:cartcount",{detail:{count:n}}); document.dispatchEvent(ev); var sels=["[data-cart-count]","[data-cart-count-bubble]",".cart-count",".cart-count-bubble",".header__icon .counter",".header__icon .cart-count",".header__icon--cart .cart-count",".header__icon--cart [aria-hidden]",".ub2r-header-cart .ub2r-count"]; sels.forEach(function(q){ document.querySelectorAll(q).forEach(function(node){ node.textContent=String(n); var b=node.closest(".cart-count-bubble,[data-cart-count-bubble]"); if(b){ b.removeAttribute("hidden"); b.style.display=(n>0)?"inline-flex":"none" }})}) }
  function tick(){ fetch("/cart.js",{credentials:"same-origin"}).then(function(r){return r.json()}).then(function(c){ reflect(c.item_count||0) }).catch(function(){}) }
  function ensure(){
    if(overlay) return;
    overlay=document.createElement("div");
    overlay.id="ub2r-cart-overlay";
    overlay.innerHTML='<div class="ub2r-cart-stage"><button class="ub2r-cart-back" type="button" aria-label="Close"><span>&lt;</span></button><div class="ub2r-cart-content" role="region" aria-label="Cart"></div></div>';
    document.body.appendChild(overlay);
    content=overlay.querySelector(".ub2r-cart-content");
    backBtn=overlay.querySelector(".ub2r-cart-back");
    backBtn.addEventListener("click",function(e){e.preventDefault();overlay.style.pointerEvents="none";setTimeout(function(){overlay.style.pointerEvents="";},120); (function(){try{var p=document.querySelector("#ub2r-overlay");if(p){p.setAttribute("data-ub2r-preserved","1")}}catch(_){} })(); close(true)});
    overlay.addEventListener("click",function(e){ if(e.target===overlay) close(true) });
    var css=document.createElement("style");
    css.textContent="#ub2r-cart-overlay{position:fixed;inset:0;z-index:2147483650;background:rgba(0,0,0,.06);backdrop-filter:saturate(180%) blur(6px);display:none}#ub2r-cart-overlay .ub2r-cart-stage{position:absolute;inset:0;background:var(--color-background,#fff);overflow:auto;-webkit-overflow-scrolling:touch}#ub2r-cart-overlay .ub2r-cart-back{position:absolute;top:10px;left:10px;height:36px;width:36px;border:0;background:transparent;color:inherit;z-index:2}#ub2r-cart-overlay .ub2r-cart-content{min-height:100%;}";
    document.head.appendChild(css);
    if(!historyBound){ window.addEventListener("popstate",function(){ if(openState){ hide(); openState=false }});
    historyBound=true }
    bindDelegates();
  }
  function show(){
    ensure();
    (function(){var p=document.querySelector("#ub2r-overlay");if(p){var s=getComputedStyle(p);if(s.display!=="none"&&s.visibility!=="hidden"){p.style.display="none";p.setAttribute("data-ub2r-preserved","1");}}})();
    overlay.style.display="block";
    document.body.style.overflow="hidden";
    openState=true;
    loadCart();
    if(timer) clearInterval(timer);
    timer=setInterval(tick,1500);
  }
  function hide(){ overlay.style.display="none"; document.body.style.overflow=""; if(timer){ clearInterval(timer); timer=null } }
  function close(fromUi){ if(!openState) return;
    hide(); openState=false; if(fromUi){ try{}catch(e){} } }
  function loadCart(){
    content.innerHTML='<div style="display:flex;align-items:center;justify-content:center;min-height:60vh">Loading…</div>';
    fetch("/?section_id=main-cart",{credentials:"same-origin"})
      .then(function(r){return r.text()})
      .then(function(html){
        content.innerHTML=html;
        assignLines();
        tick();
      })
      .catch(function(){ content.innerHTML='<div style="padding:24px">Failed to load cart.</div>' });
  }
  function assignLines(){
    var inputs = content.querySelectorAll('input[name^="updates"], input.quantity__input, input[type="number"]');
    var i = 0;
    inputs.forEach(function(inp){
      if(!/updates/.test(inp.name||"")) return;
      i+=1;
      inp.dataset.line = String(i);
    });
  }
  function getLineByChild(el){
    var inp = el.closest("tr, .cart-item, .cart-line-item, li, div").querySelector('input[name^="updates"], input.quantity__input, input[type="number"]');
    if(!inp){ var all = Array.prototype.slice.call(content.querySelectorAll('input[name^="updates"], input.quantity__input, input[type="number"]')); var idx = all.indexOf(el.closest("input,button,svg,span,a").querySelector('input[name^="updates"], input.quantity__input, input[type="number"]'));
    if(idx>-1) return String(idx+1) }
    if(!inp){ var all2 = Array.prototype.slice.call(content.querySelectorAll('input[name^="updates"], input.quantity__input, input[type="number"]'));
    var host = el.closest("tr, .cart-item, .cart-line-item, li, div"); for(var k=0;k<all2.length;k++){ if(host && host.contains(all2[k])){ inp = all2[k];
    break } } }
    return inp && (inp.dataset.line || String(Array.prototype.indexOf.call(content.querySelectorAll('input[name^="updates"], input.quantity__input, input[type="number"]'), inp)+1));
  }
  function currentQtyForLine(line){
    var inputs = content.querySelectorAll('input[name^="updates"], input.quantity__input, input[type="number"]');
    var i = parseInt(line,10)-1;
    var inp = inputs[i];
    var v = inp?parseInt(inp.value||inp.getAttribute("value")||"0",10):0;
    return isNaN(v)?0:v;
  }
  function updateLine(line, qty){
    if(!line) return;
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},credentials:"same-origin",body:JSON.stringify({line:parseInt(line,10),quantity:parseInt(qty,10)})})
      .then(function(r){return r.json()})
      .then(function(){ loadCart() })
      .catch(function(){ loadCart() });
  }
  function bindDelegates(){
    content && content.addEventListener("click", function(e){
      var minus = e.target.closest('button[name="minus"], .quantity__button--minus, [data-quantity-dec], .js-qty__adjust--minus');
      var plus  = e.target.closest('button[name="plus"], .quantity__button--plus, [data-quantity-inc], .js-qty__adjust--plus');
      var remove= e.target.closest('[data-remove], .cart-remove, a[href*="/cart/change?line="], button[name="remove"]');
      if(minus){ e.preventDefault(); var line = getLineByChild(minus); var q = Math.max(0, currentQtyForLine(line)-1); updateLine(line,q); return }
      if(plus){ e.preventDefault(); var line2 = getLineByChild(plus); var q2 = currentQtyForLine(line2)+1; updateLine(line2,q2); return }
      if(remove){ e.preventDefault(); var line3 = getLineByChild(remove); updateLine(line3,0); return }
   
    }, true);
    content && content.addEventListener("change", function(e){
      var inp = e.target.closest('input[name^="updates"], input.quantity__input, input[type="number"]');
      if(!inp) return;
      var line = inp.dataset.line || getLineByChild(inp) || "1";
      var v = parseInt(inp.value||"0",10); if(isNaN(v)||v<0) v=0;
      updateLine(line,v);
    });
    content && content.addEventListener("submit", function(e){
      var form = e.target;
      if(form && /\/cart/.test(form.getAttribute("action")||"")) {
        setTimeout(function(){ hide(); }, 50);
      }
    }, true);
  }
  function intercept(){
    document.addEventListener("click", function(e){
      var a = e.target.closest('a[href*="/cart"], .header__icon--cart, [data-action="open-cart"]');
      if(!a) return;
      var href=a.getAttribute("href")||"";
      if(href && href.indexOf("/cart")===-1 && !a.classList.contains("header__icon--cart")) return;
      var plainClick = (e.button===0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey);
      if(!plainClick) return;
      e.preventDefault();
      show();
    });
  }
  function boot(){ intercept() } window.ub2rOpenCart=show; document.addEventListener("ub2r:openCart",function(){show()});
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded", boot) } else { boot() }
})();
(function(){
  function __ub2r_openCartFallback(){
    if(window.ub2rOpenCart){
      try{ window.ub2rOpenCart(); return }catch(e){}
    }
    try{ document.dispatchEvent(new Event("ub2r:openCart")); }catch(e){}
    try{ location.href="/cart" }catch(e){}
  }
  function shouldOpenCart(target){
    return !!(target.closest(".ub2r-cartbtn") ||
              target.closest(".header__icon--cart") ||
              target.closest("[data-action='open-cart']") ||
              target.closest("a[href='/cart']") ||
           
           target.closest("a[href^='/cart?']"));
  }
  document.addEventListener("pointerdown", function(e){
    if(!shouldOpenCart(e.target)) return;
    e.preventDefault();
    __ub2r_openCartFallback();
  }, true);
  document.addEventListener("click", function(e){
    if(!shouldOpenCart(e.target)) return;
    e.preventDefault();
    __ub2r_openCartFallback();
  }, true);
  document.addEventListener("keydown", function(e){
    if((e.key!=="Enter" && e.key!==" ") ||
        !shouldOpenCart(e.target)) return;
    e.preventDefault();
    __ub2r_openCartFallback();
  }, true);
})();

(function(){
if(window.__ub2r_cart_capture_installed) return; window.__ub2r_cart_capture_installed=true; var __opening=false;
function overlayOpen(){var el=document.querySelector("#ub2r-overlay");if(!el) return false;var s=window.getComputedStyle(el);if(s.display==="none"||s.visibility==="hidden"||s.pointerEvents==="none") return false;return true}
function rects(){var r=[];var a=document.querySelector("#ub2r-overlay .ub2r-cartbtn");if(a) r.push(a.getBoundingClientRect());var b=document.querySelector("#ub2r-overlay .ub2r-cartbtn svg");if(b) r.push(b.getBoundingClientRect());var c=document.querySelector("#ub2r-overlay .ub2r-cartbtn .ub2r-count");if(c) r.push(c.getBoundingClientRect());var h=document.querySelector(".header__icon--cart, .header__icon--cart a");if(h) r.push(h.getBoundingClientRect());return r}
function inside(x,y,t){return x>=t.left&&x<=t.right&&y>=t.top&&y<=t.bottom}
function hit(x,y){var rs=rects();for(var i=0;i<rs.length;i++){if(inside(x,y,rs[i])) return true}return false}
function trigger(){if(__opening) return;
    __opening=true; setTimeout(function(){__opening=false},200);try{if(typeof window.ub2rOpenCart==="function"){window.ub2rOpenCart();return}}catch(e){}try{document.dispatchEvent(new Event("ub2r:openCart"));return}catch(e){}try{location.href="/cart"}catch(e){}}
function onPoint(e){if(!overlayOpen()) return;var x=e.clientX,y=e.clientY;if(e.touches&&e.touches.length){x=e.touches[0].clientX;y=e.touches[0].clientY}if(hit(x,y)){e.preventDefault();e.stopImmediatePropagation();trigger()}}
function onKey(e){if(!overlayOpen()) return;if(e.key!=="Enter"&&e.key!==" ") return;var a=document.activeElement;if(a&&(a.closest("#ub2r-overlay .ub2r-cartbtn")||a.closest(".header__icon--cart"))){e.preventDefault();e.stopImmediatePropagation();trigger()}}
window.addEventListener("touchstart",onPoint,{capture:true,passive:false});
window.addEventListener("pointerdown",onPoint,{capture:true});
window.addEventListener("click",onPoint,{capture:true});
window.addEventListener("keydown",onKey,{capture:true});
})();
(function(){
  if(window.__ub2r_overlay_controller_installed) return; window.__ub2r_overlay_controller_installed = true;
  function q(s,c){return (c||document).querySelector(s)}
  function isVisible(el){if(!el) return false; var s=getComputedStyle(el); return s.display!=="none" && s.visibility!=="hidden" && s.opacity!=="0"}
  function has(el,sel){return el && el.querySelector(sel)}
  function openCart(){
    try{ if(typeof window.ub2rOpenCart==="function"){ window.ub2rOpenCart(); return } }catch(e){}
    try{ document.dispatchEvent(new Event("ub2r:openCart")); return }catch(e){}
    try{ location.href="/cart" }catch(e){}
  }
  function productOverlay(){ return q("#ub2r-overlay") }
  function cartOverlay(){ return q("#ub2r-cart-overlay") }
  function preserveProduct(){
    var p = productOverlay(); if(!p) return false;
    if(!isVisible(p)) return false;
    p.setAttribute("data-ub2r-preserved","1");
    p.style.display="none";
   
    return true;
  }
  function restoreProduct(){
    var p = productOverlay();
    if(!p) return false;
    if(p.getAttribute("data-ub2r-preserved")!=="1") return false;
    p.style.display="block";
    p.removeAttribute("data-ub2r-preserved");
    return true;
  }
  function onProductCartClick(e){
    var t = e.target;
    var hit = t && (t.closest("#ub2r-overlay .ub2r-cartbtn") || t.closest("#ub2r-overlay [data-action='open-cart']") || t.closest("#ub2r-overlay a[href='/cart']") || t.closest("#ub2r-overlay a[href^='/cart?']"));
    if(!hit) return;
    e.preventDefault();
    if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    preserveProduct();
    openCart();
  }
  function onProductKey(e){
    if(e.key!=="Enter" && e.key!==" ") return;
    var a=document.activeElement;
    if(!a) return;
    var hit = a.closest("#ub2r-overlay .ub2r-cartbtn, #ub2r-overlay [data-action='open-cart'], #ub2r-overlay a[href='/cart'], #ub2r-overlay a[href^='/cart?']");
    if(!hit) return;
    e.preventDefault(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    preserveProduct();
    openCart();
  }
  function onCartBack(e){
    var t=e.target;
    var back = t && t.closest("#ub2r-cart-overlay .ub2r-cart-back");
    if(!back) return;
    setTimeout(function(){
      if(restoreProduct()){
        var c = cartOverlay(); if(c){ c.style.display="none" }
      }
    }, 30);
  }
  window.addEventListener("click", onProductCartClick, {capture:true});
  window.addEventListener("keydown", onProductKey, {capture:true});
  window.addEventListener("click", onCartBack, {capture:true});
})();
(function(){
  var style=document.getElementById('ub2r-mobile-arrows')||document.createElement('style');
  style.id='ub2r-mobile-arrows';
  style.textContent='@media (max-width: 749px){#MainContent[data-template="product"] media-gallery,#MainContent[data-template="product"] media-gallery .slider-component,#MainContent[data-template="product"] .slider-component.slider-mobile-gutters{position:relative!important;z-index:0!important}#MainContent[data-template="product"] .slider-component .slider-buttons{position:absolute!important;inset:0!important;top:0!important;bottom:auto!important;pointer-events:none!important;z-index:3!important}#MainContent[data-template="product"] .slider-component .slider-buttons .slider-button,#MainContent[data-template="product"] button[aria-label="Previous"].slider-button,#MainContent[data-template="product"] button[aria-label="Next"].slider-button{position:absolute!important;top:50%!important;transform:translateY(-50%)!important;pointer-events:auto!importan}#MainContent[data-template="product"] .slider-component .slider-buttons .slider-button--prev,#MainContent[data-template="product"] button[aria-label="Previous"].slider-button{left:min(6vw,24px)!important;right:auto!important}#MainContent[data-template="product] .slider-component .slider-buttons .slider-button--next,#MainContent[data-template="product"] button[aria-label="Next"].slider-button{right:min(6vw,24px)!important;left:auto!important}}';
  document.head.appendChild(style);
})();

(function(){
  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches }
  function align(){
    var root=document.getElementById('ub2r-overlay');
    if(!root || !isMobile()) return;
    var stage=root.querySelector('.ub2r-stage');
    var media=root.querySelector('.ub2r-media');
    var prev=root.querySelector('.ub2r-nav--prev');
    var next=root.querySelector('.ub2r-nav--next');
    if(!stage||!media||!prev||!next) return;
    var sr=stage.getBoundingClientRect(), mr=media.getBoundingClientRect();
    if(mr.height<10) return;
    var y=(mr.top - sr.top) + mr.height/2;
    [prev,next].forEach(function(b){
      b.style.position='absolute';
      b.style.top=y+'px';
      b.style.bottom='auto';
      b.style.transform='translateY(-50%)';
   
       b.style.pointerEvents='auto';
      b.style.zIndex='6';
    });
  }
  function boot(){
    try{ new ResizeObserver(align).observe(document.body) }catch(e){}
    window.addEventListener('resize',align,{passive:true});
    window.addEventListener('orientationchange',align);
    document.addEventListener('ub2r:media-change',align);
    document.addEventListener('ub2r:overlay-open',align);
    document.addEventListener('ub2r:overlay-close',align);
    setTimeout(align,60);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot) } else { boot() }
})();